define('lq/conditions/conditions',[
    'underscore', 
    './conditionEvaluator'
], function (_, ConditionEvaluator) {
    'use strict';

    var Conditions = function (conditions, piping) {
        this.piping = piping;

        this.conditionsById = {};
        this.evaluatorsById = {};

        var self = this;
        _.each(conditions, function (condition) {
            self.conditionsById[condition.id] = condition;
        });
    };

    Conditions.supportedValues = ['View', 'Query', 'Value', 'Parameter'];
    Conditions.supportedOperators = ['=', '≠', '>', '≥', '≤', '<', 'contains'];

    Conditions.prototype.getConditionEvaluator = function (idOfCondition) {
        if (this.evaluatorsById[idOfCondition] === undefined) {
            if (this.conditionsById[idOfCondition] === undefined)
                throw new Error('Condition with id ' + idOfCondition + ' does not exist.');

            var condition = this.conditionsById[idOfCondition];
            this.evaluatorsById[idOfCondition] = new ConditionEvaluator(condition, this.piping);
        }

        return this.evaluatorsById[idOfCondition];
    };

    return Conditions;
});
